import { render, staticRenderFns } from "./BlackPeriodList.vue?vue&type=template&id=708ce26e&"
import script from "./BlackPeriodList.vue?vue&type=script&lang=js&"
export * from "./BlackPeriodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports